import React from 'react'
import { Outlet } from 'react-router-dom'

function MainConsultants() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainConsultants
